import { kioskLocation } from "../App/kioskRoutes";
import { ModalCloseButton } from "./LucidePrimitives";
import {
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { useKiosk } from "../Contexts/KioskContext";

function getTierContent(count) {
  if (count >= 6) {
    return {
      header: "Urgent: Please check out",
      body: `You have forgotten to check out ${count} times in a row. Your space access may be reviewed if this continues. You must check out every time you leave.`,
    };
  } else if (count >= 4) {
    return {
      header: "Please take checkout seriously",
      body: `You have forgotten to check out ${count} times in a row. This forces space staff to manually correct records and prevents other students from seeing which equipment is actually available.`,
    };
  } else if (count >= 2) {
    return {
      header: "Remember to check out!",
      body: `You have now forgotten to check out ${count} times in a row. When you don't check out, tools appear in use after you've left, preventing others from knowing what's available.`,
    };
  }
  return {
    header: "Remember to check out!",
    body: "Last time you used a space, you forgot to check out when you were done. Please remember to check out whenever you are finished using a space.",
  };
}

export default function SwipeOutReminderPopup({ isOpen, onClose, onCheckout, count = 1 }) {
  const history = useHistory();
  const { isKiosk } = useKiosk();
  const { header, body } = getTierContent(count);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      aria-labelledby="swipe-reminder-header"
      aria-describedby="swipe-reminder-body"
    >
      <ModalOverlay />
      <ModalContent rounded="lg" p={isKiosk ? 8 : undefined}>
        <ModalHeader
          id="swipe-reminder-header"
          color="gray.800"
          fontSize={isKiosk ? "2xl" : undefined}
          fontWeight={700}
        >
          {header}
        </ModalHeader>
        <ModalCloseButton
          aria-label="Close dialog"
          {...(isKiosk && { size: "lg", p: 4 })}
        />
        <ModalBody id="swipe-reminder-body">
          <Text color="gray.600" fontSize={isKiosk ? "xl" : undefined}>
            {body}
          </Text>
        </ModalBody>
        <ModalFooter flexDirection="column">
          <Button
            {...(isKiosk && { size: "kiosk", w: "full" })}
            onClick={() => {
              onCheckout();
              history.push(kioskLocation("/kiosk/check-in/purpose", history.location));
              onClose();
            }}
          >
            I Understand
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
